import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { NewsResponse } from '../../models/news/pitchin-news-blog';

@Injectable({
  providedIn: 'root',
})
export class PitchinNewsService {
  private readonly baseUrl = 'https://news.pitchin.my';

  constructor(private http: HttpClient) {}

  getBlogs(): Observable<NewsResponse> {
    const params = { 'noToken': 'noToken' };
    return this.http.get(this.baseUrl + '/_functions/blogs', { params }).pipe(
      map((response: NewsResponse) => {
        return response;
      }),
    );
  }
}
